import React, { useEffect } from "react";
import {thousandSeparatorFormat} from "../../library/helper";
import {useTranslation} from "react-i18next";

const STYLE_ID = "hoverable-inline-css";
const CSS = `
.hoverable{
  position:relative;
  display:inline-flex;
  align-items:center;
  gap:0; /* avoid unintended spacing inside <td> */
  cursor: zoom-in;
  cursor: -webkit-zoom-in;
}
.hoverable .hoverable-tip{
  position:absolute;
  padding:6px 10px;
  background:#111; color:#fff;
  border-radius:8px; font-size:12px; line-height:1;
  white-space:nowrap;
  box-shadow:0 8px 24px rgba(0,0,0,.18);
  opacity:0; visibility:hidden; z-index:20;
  transition:opacity .15s ease, transform .15s ease, visibility .15s linear;
}
.hoverable:hover .hoverable-tip,
.hoverable:focus-within .hoverable-tip{ opacity:1; visibility:visible; }

/* top (default) */
.hoverable-top .hoverable-tip{ left:50%; bottom:100%; transform:translate(-50%,-6px); }
.hoverable-top:hover .hoverable-tip,
.hoverable-top:focus-within .hoverable-tip{ transform:translate(-50%,-10px); }
.hoverable-top .hoverable-tip::after{
  content:""; position:absolute; top:100%; left:50%; transform:translateX(-50%);
  border:6px solid transparent; border-top-color:#111;
}

/* bottom */
.hoverable-bottom .hoverable-tip{ left:50%; top:100%; transform:translate(-50%,6px); }
.hoverable-bottom:hover .hoverable-tip,
.hoverable-bottom:focus-within .hoverable-tip{ transform:translate(-50%,10px); }
.hoverable-bottom .hoverable-tip::after{
  content:""; position:absolute; bottom:100%; left:50%; transform:translateX(-50%);
  border:6px solid transparent; border-bottom-color:#111;
}

/* left */
.hoverable-left .hoverable-tip{ right:100%; top:50%; transform:translate(-6px,-50%); }
.hoverable-left:hover .hoverable-tip,
.hoverable-left:focus-within .hoverable-tip{ transform:translate(-10px,-50%); }
.hoverable-left .hoverable-tip::after{
  content:""; position:absolute; left:100%; top:50%; transform:translateY(-50%);
  border:6px solid transparent; border-left-color:#111;
}

/* right */
.hoverable-right .hoverable-tip{ left:100%; top:50%; transform:translate(6px,-50%); }
.hoverable-right:hover .hoverable-tip,
.hoverable-right:focus-within .hoverable-tip{ transform:translate(10px,-50%); }
.hoverable-right .hoverable-tip::after{
  content:""; position:absolute; right:100%; top:50%; transform:translateY(-50%);
  border:6px solid transparent; border-right-color:#111;
}
`;

function ensureStyles() {
    if (typeof document === "undefined") return; // SSR guard
    if (!document.getElementById(STYLE_ID)) {
        const el = document.createElement("style");
        el.id = STYLE_ID;
        el.textContent = CSS;
        document.head.appendChild(el);
    }
}

export default function Hoverable({
                                      children,
                                      content,
                                      position = "top",      // 'top' | 'bottom' | 'left' | 'right'
                                      className = "",
                                      style,
                                      cursor = "zoom-in",    // override if needed ('pointer', 'default', etc.)
                                  }) {
    useEffect(() => { ensureStyles(); }, []);
    const classes = ["hoverable", `hoverable-${position}`, className].filter(Boolean).join(" ");
    const mergedStyle = { ...style, cursor, margin: 0, padding: 0 };
    const { t, i18n } = useTranslation()

    // treat 0 and undefined/null as empty => show "-"
    const isEmpty =
        content === 0 ||
        content === null ||
        content === undefined ||
        (typeof content === "string" && content.trim() === "");

    const formattedContent =
        typeof content === "number"
            ? thousandSeparatorFormat(content, i18n.language)
            : content;


    return (
        <span className={classes} style={mergedStyle} tabIndex={0}>
      {children}
            <span role="tooltip" className="hoverable-tip">
        {isEmpty ? "-" : formattedContent}
      </span>
    </span>
    );
}
